import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default React.memo(Icon);

Icon.propTypes = {
  /** Icon css name (ignored if label is provided)*/
  name: PropTypes.string,
  /** Icon ligature text */
  label: PropTypes.string,
};

/**
 * **Access:**
 * ```js
 * import {Icon} from '@iss/client-react-components'
 * ```
 * Renders an Icon glyph by name.
 *
 * @class Icon
 * @component
 */
function Icon({ name, label, className }) {
  if (label) {
    name = 'icon-ligature';
  }

  return <i className={cx(name, className)} children={label} />;
}
